import { TitlesState } from "core/state/titles/reducer";
import { metaSelector } from "core/state/comon";

export const getTitles = (
  { titles }: { titles: TitlesState },
  projectId: string
) => metaSelector(titles, projectId, null, []);
